import React from 'react'
import { useHistory } from 'react-router'
import List from './List/List'
import styles from '../Users/UsersPage.module.css'


const UsersPage = () => {

    const history = useHistory()
    const user = JSON.parse(localStorage.getItem('profile'))
    
    if (user.result.role !== 'admin') {
        return (<div>{history.push('/')}</div>)
    }
    return (
        <div className={styles.usersContainer}>
            <List />
        </div>
    )
}

export default UsersPage
